<ng-container *ngIf="baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseBlock"
              cardBody>
  <app-card-empty icon="{{ STRING_CONSTANTS.ICON.IC_SALES_ORDER }}"
                  text="Tidak terdapat Sales Order."></app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <!-- begin::Card -->
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <!--begin::Card header-->
    <ng-container cardHeader>
      <h5 class="fw-bolder d-flex w-100 align-items-center mb-0">
        <span>{{ title }}</span>
      </h5>
    </ng-container>
    <!--end::Card header-->

    <!--begin::Card body-->
    <ng-container cardBody>
      <app-note-view [color]="'info'" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"
                     [text]="'Menampilkan Sales Order dari Distributor dalam 3 bulan terakhir.'">
      </app-note-view>

      <div class="table-responsive">
        <table (matSortChange)="sortTable($event)" [dataSource]="baseDatasource"
               class="table w-100 gy-5 table-row-bordered align-middle" mat-table matSort>
          <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
            <!-- COLUMN HEADER -->
            <ng-container *ngIf="tableColumn.isSortable; else notSortable">
              <th
                *matHeaderCellDef
                [arrowPosition]="'after'"
                [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'code'"
                [mat-sort-header]="tableColumn.key"
                class="min-w-125px px-3"
                mat-header-cell
              >
                <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                  {{ tableColumn.title }}
                </div>
                <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                  <app-table-content [width]="70"></app-table-content>
                </div>
              </th>
            </ng-container>
            <ng-template #notSortable>
              <th
                *matHeaderCellDef
                [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                [ngClass]="{
                    'min-w-70px text-center': tableColumn.key === 'actions',
                    'w-500px': tableColumn.key === 'distributor_name'
                  }"
                class="min-w-125px px-3"
                mat-header-cell
              >
                <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                  {{ tableColumn.title }}
                </div>
                <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                  <app-table-content [width]="70"></app-table-content>
                </div>
              </th>
            </ng-template>

            <!-- COLUMN DATA -->
            <td *matCellDef="let element" class="px-3" mat-cell>
              <!-- {{ element[tableColumn.key]}} -->
              <ng-container [ngSwitch]="tableColumn.key">
                <div *ngSwitchCase="'createdDate'">
                  <app-table-content [count]="2" [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                                     [type]="'text'">
                    <div>{{ element['created_date'] ? utilities.timeStampToDate(element['created_date'], 'dd-MM-yyyy') : '-' }}</div>
                    <div>{{ utilities.timeStampToDate(element['created_date'], 'HH:mm:ss') }}</div>
                  </app-table-content>
                </div>

                <div *ngSwitchCase="'status'">
                  <app-table-content [height]="30" [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                                     [width]="120">
                      <span class="badge badge__status {{ 'badge__status--' + element['status_enum'] }}">
                        {{ element['status_string'] ? element['status_string'] : '-' }}
                      </span>
                  </app-table-content>
                </div>

                <div *ngSwitchCase="'total_invoice'">
                  <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                    <span>{{ utilities.toRupiah(element['total_invoice']) }}</span>
                  </app-table-content>
                </div>

                <div *ngSwitchDefault>
                  <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                    <span>{{ element[tableColumn.key] ?? '-' }} </span>
                  </app-table-content>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>
      </div>

      <div class="d-flex justify-content-between py-4">
        <app-mai-material-bottom-table
          (changePage)="changePageEvent($event)"
          [baseDataTableComponent]="baseDatasource"
          [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
          class="w-100"
        ></app-mai-material-bottom-table>
      </div>
    </ng-container>
    <!--end::Card body-->
  </app-card>
  <!-- end::Card -->
</ng-template>
